import { createElement } from 'react';

/**
 * Único componente para todos los títulos del producto. Centraliza la escala
 * tipográfica (h1/h2/h3) en un solo lugar. Default Inter; con `editorial` en
 * h1 cambia a Fraunces para voz pedagógica.
 *
 * @param {Object}  props
 * @param {'h1'|'h2'|'h3'} [props.level='h1']  Nivel semántico y visual.
 * @param {boolean} [props.editorial=false]    Solo válido con level='h1'.
 *                                              Renderiza en Fraunces.
 * @param {string}  [props.as]                  HTML tag a renderizar.
 *                                              Default = level.
 * @param {string}  [props.className='']        Extensión opcional.
 * @param {React.ReactNode} props.children
 */
export default function Heading({
  level = 'h1',
  editorial = false,
  as,
  className = '',
  children,
}) {
  const sizeClass =
    level === 'h1' ? 'text-h1' : level === 'h2' ? 'text-h2' : 'text-h3';

  // editorial solo aplica a h1 — en h2/h3 se ignora deliberadamente.
  const familyClass = editorial && level === 'h1' ? 'font-serif' : 'font-sans';
  const tag = as || level;

  return createElement(
    tag,
    { className: `${sizeClass} ${familyClass} ${className}`.trim() },
    children
  );
}
